import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Modal, Form, Row, Col, Table, Dropdown, Badge } from 'react-bootstrap';
import { MdAirplaneTicket, MdLandslide, MdMoneyOff, MdOutlineDiscount, MdOutlineSupport, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCodePromosAll, fetchCodePromosOfIdUserAll, createPromoCode, fetchCodePromoByUpdateId, fetchCodePromoById } from '../../../actions/request/CodePromoRequest';
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../../utils/storage/localvalue';
import { toast } from 'react-toastify';
import { RiFileDamageFill } from 'react-icons/ri';
import { CompanyAiportCreate, CompanyAiportUpdatById, fetchCompanyAiportsAll } from '../../../actions/request/CompanyAiportRequest';
import { fetchExpenseCategorysAll } from '../../../actions/request/ExpenseCategoryRequest';
import { MaintenanceCreate, MaintenanceUpdateById } from '../../../actions/request/MaintenanceRequest';
import { MaintenanceCategoryCreate, MaintenanceCategoryUpdateById, fetchMaintenanceCategorysAll } from '../../../actions/request/MaintenanceCategoryRequest';
import { FaTools } from 'react-icons/fa';
import { patrimoineTypes } from '../../../utils/dataApi/dataFormApi';
import { CategoryExpenseBigCreate, CategoryExpenseBigUpdateById, fetchCategoryExpenseBigsAll } from '../../../actions/request/CategoryExpnsesBigRequest';

const CategoryExpensePage = () => {


    const dispatch = useDispatch();
    // const maintenanceCategorys = useSelector((state) => state.maintenanceCategorys.maintenanceCategorys);
    const categoryexpensebigs = useSelector((state) => state.categoryexpensebigs.categoryexpensebigs);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [promoCodeData, setPromoCodeData] = useState({
        name: '',
        description: '',
        patrimoine: "",
        categoryexpensebig: "",
        maintenance: false,
        expense: false,
        damage: false,
        insurance: false,
    });
    const [selectedPromoCode, setSelectedPromoCode] = useState(null);
    const [showCode, setShowCode] = useState({});
    const itemsPerPage = 50;

    useEffect(() => {
        dispatch(fetchCategoryExpenseBigsAll());
    }, [dispatch]);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setPromoCodeData({ name: "", description: "" });
        setSelectedPromoCode(null);
    };

    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;

        // Si c'est une case à cocher, utilisez "checked". Sinon, utilisez "value".
        setPromoCodeData((prevState) => ({
            ...prevState,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleInputRatioChange = (e) => {
        const { name, value } = e.target;

        // Mettre à jour l'état avec la nouvelle valeur
        setPromoCodeData((prevState) => ({
            ...prevState,
            [name]: parseFloat(value) || 0, // Convertir la valeur en nombre
        }));

        // Normaliser les ratios
        normalizeRatios();
    };


    const normalizeRatios = () => {
        const total = promoCodeData.maintenance + promoCodeData.expense + promoCodeData.damage + promoCodeData.insurance;
        if (total === 0) return; // Éviter la division par zéro

        setPromoCodeData((prevState) => ({
            ...prevState,
            maintenance: prevState.maintenance / total,
            expense: prevState.expense / total,
            damage: prevState.damage / total,
            insurance: prevState.insurance / total,
        }));
    };

    const handleCreateOrUpdatePromoCode = () => {
        if (selectedPromoCode) {
            if (!promoCodeData.name && !promoCodeData.description) {
                toast.error("Veillez renseignez tous les champs s'il vous plait . ", { position: "bottom-right" })
                return;
            }
            dispatch(CategoryExpenseBigUpdateById(selectedPromoCode?._id, promoCodeData));
        }
        else {
            // const userAdd = getAndCheckLocalStorage(localStorageKeys.userId);
            if (!promoCodeData.name && !promoCodeData.description) {
                toast.error("Veillez renseignez tous les champs s'il vous plait . ", { position: "bottom-right" })
                return;
            }
            dispatch(CategoryExpenseBigCreate({ ...promoCodeData }));
        }
        handleCloseModal();
    };

    const handleEditPromoCode = (promoCode) => {
        setSelectedPromoCode(promoCode);
        setPromoCodeData({
            name: promoCode.name,
            description: promoCode.description,
            patrimoine: promoCode.patrimoine,
            categoryexpensebig: promoCode.patrimoine,
        });
        handleShowModal();
    };

    const handleValidatePromoCode = (code) => {
        dispatch(fetchCodePromoById(code));
    };

    const handleToggleShowCode = (promoId) => {
        setShowCode((prevState) => ({ ...prevState, [promoId]: !prevState[promoId] }));
    };

    const paginatedPromoCodes = categoryexpensebigs.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) || [];



    return (
        <div>
            <Card>
                <Card.Header>
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <h3 className="mb-4"><FaTools /> Grandes catégories de dépenses </h3>
                        </div>
                        <div>
                            <Button title="Ajouter une nouvelle grande catégorie de dépense"
                                variant="primary"
                                size='sm'
                                className="ml-2"
                                onClick={handleShowModal}
                            >
                                + Ajouter
                            </Button>
                        </div>
                    </div>
                </Card.Header>

                <Card.Body style={{ minHeight: "400px" }} >
                    {paginatedPromoCodes && paginatedPromoCodes.length > 0 ? (
                        <div className="align-content-between">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Titre</th>
                                        <th>Option</th>
                                        <th>Description</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedPromoCodes.map((promo) => (
                                        <tr key={promo._id}>
                                            <td>
                                                {promo?.name || ""}
                                                <br />
                                                

                                            </td>
                                            <td>
                                                {
                                                    promo.maintenance ?
                                                        <Badge bg="secondary">Entretien et maintenance</Badge>
                                                        :
                                                        promo.expense ?
                                                            <Badge bg="secondary">Dépense réservations</Badge>
                                                            :
                                                            promo.damage ?
                                                                <Badge bg="secondary">Domage</Badge>
                                                                :
                                                                promo.insurance ?
                                                                    <Badge bg="secondary">Assurance</Badge>
                                                                    :
                                                                    <div></div>
                                                }
                                            </td>
                                            <td>{promo?.description || ""}</td>
                                            <td>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="primary" size="sm">
                                                        Actions
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => handleEditPromoCode(promo)}>Modifier</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <div className="d-flex justify-content-start mt-4">
                                <Button
                                    variant="primary"
                                    size="sm" className="p-2"
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    Précédent
                                </Button>
                                <Button
                                    variant="primary"
                                    size="sm" className="p-2"
                                    disabled={currentPage * itemsPerPage >= categoryexpensebigs.length}
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                    Suivant
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <Alert variant="light" style={{ display: "flex", justifyContent: "center" }}>Aucun élément</Alert>
                    )}
                </Card.Body>
            </Card>

            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedPromoCode ? "Modifier grande catégorie de dépenses" : "Nouveau grande catégorie de dépenses"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="discountPercentage">
                            <Form.Label>Titre<span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                style={{ height: "40px" }}
                                type="text"
                                name="name"
                                placeholder=''
                                value={promoCodeData.name}
                                onChange={handleInputChange}
                            />
                        </Form.Group>


                        <Form.Group controlId="maintenanceCheckbox">
                            <Form.Check
                                type="checkbox"
                                label="Maintenance"
                                name="maintenance"
                                checked={promoCodeData.maintenance}
                                onChange={(e) => {
                                    handleInputChange(e);
                                    setPromoCodeData((prevState) => ({
                                        ...prevState,
                                        expense: false,
                                        damage: false,
                                        insurance: false,
                                    }));
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="expenseCheckbox">
                            <Form.Check
                                type="checkbox"
                                label="Dépense"
                                name="expense"
                                checked={promoCodeData.expense}
                                onChange={(e) => {
                                    handleInputChange(e);
                                    setPromoCodeData((prevState) => ({
                                        ...prevState,
                                        maintenance: false,
                                        damage: false,
                                        insurance: false,
                                    }));
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="damageCheckbox">
                            <Form.Check
                                type="checkbox"
                                label="Dommage"
                                name="damage"
                                checked={promoCodeData.damage}
                                onChange={(e) => {
                                    handleInputChange(e);
                                    setPromoCodeData((prevState) => ({
                                        ...prevState,
                                        maintenance: false,
                                        expense: false,
                                        insurance: false,
                                    }));
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="insuranceCheckbox">
                            <Form.Check
                                type="checkbox"
                                label="Assurance"
                                name="insurance"
                                checked={promoCodeData.insurance}
                                onChange={(e) => {
                                    handleInputChange(e);
                                    setPromoCodeData((prevState) => ({
                                        ...prevState,
                                        maintenance: false,
                                        expense: false,
                                        damage: false,
                                    }));
                                }}
                            />
                        </Form.Group>



                        <Form.Group controlId="expiryDate">
                            <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as={"textarea"}
                                style={{ height: "50px" }}
                                type="text"
                                name="description"
                                value={promoCodeData.description}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" size="sm" onClick={handleCloseModal}>Annuler</Button>
                    <Button variant="primary" size="sm" onClick={handleCreateOrUpdatePromoCode}>{selectedPromoCode ? 'Mettre à Jour' : 'Créer'}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CategoryExpensePage;